<template>
  <v-dialog v-model="show" hide-overlay :fullscreen="$vuetify.breakpoint.xsOnly" scrollable max-width="900px" :transition="transition">
    <v-card color="white" style="min-height:600px;" >
      <v-toolbar flat color="transparent">
          <v-toolbar-title color="primary">Privacy Policy</v-toolbar-title>
        <v-spacer></v-spacer>
            <v-btn flat icon @click="this.cancel">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
    <p class="c2"><span class="c4">Updated: November 01, 2017</span></p>
    <p class="c2"><span>Effective: November 01, 2017</span></p>
<p class="c2"><span>If you have joined OneChart through a partner organization, your organization may have an additional Enterprise
            Agreement that may have modified the privacy policy below. Please contact your organization&rsquo;s Administration
            for </span><span>details</span><span>.</span></p>
    <p class="c2"><span>Thanks for using OneChart! </span><span>Here we describe how we collect, use and handle your information, including
            your medical information, when you use our websites, software and services (&quot;Services&quot;), how such information
            may be disclosed and how you can get access to such information.</span><span class="c4">&nbsp;Please read it
            carefully.</span></p>
    <p class="c2"><span class="c5">What Information We Collect &amp; Why</span></p>
    <p class="c2"><span class="c4">We collect and use the following information to provide, improve and protect our Services:</span></p>
    <p
        class="c2"><span class="c1">Account</span><span class="c4">. We collect, and associate with your account, information like your
            name, email address, phone number, payment info, physical address, physician and health care provider information
            you provide, and account activity.</span></p>
    <p class="c2"><span class="c1">Services</span><span>. Our Services are a conduit designed to make it simple for you to access personal
            health information you request through your OneChart account (&ldquo;</span><span>Your Chart</span><span>&rdquo;),
            share Your Chart data with others, and view Your Chart across multiple devices. Only you and the individuals
            you designate can see Your Chart. You are given the ability to share and un-share Your Chart with whomever you
            like. To make all of this possible, we </span><span>store</span><span>, </span><span>process</span><span class="c4">,
            and transmit Your Chart as well as information related to it. As a mere conduit, we touch the minimum amount
            of protected health information, if any, necessary to provide you the Services.</span></p>
    <p class="c2"><span class="c1">Usage</span><span>. We collect </span><span>information related to how you use the Services</span><span
            class="c4">, including actions you take in your account (like sharing, editing, viewing, and moving files or folders).
            This helps us provide you with features like the &quot;Recently Viewed&quot; page and version history.</span></p>
    <p
        class="c2"><span>We also </span><span class="c4">collect information from and about the devices you use to access the Services.
            This includes things like IP addresses, the type of browser and device you use, the web page you visited before
            coming to our sites, and identifiers associated with your devices. Your devices (depending on their settings)
            may also transmit location information to the Services.</span></p>
    <p class="c2"><span class="c1">Cookies and other technologies</span><span>. We use technologies like cookies and pixel tags&nbsp;to
            provide, improve, protect and promote our Services. For example, cookies help us with things like remembering
            your username for your next visit, understanding how you are interacting with our Services, and improving them
            based on that information. You can set your browser to not accept cookies, but this may limit your ability to
            use the Services. If our systems receive a DNT signal from your browser, we&#39;ll respond to that signal as
            outlined </span><span>here</span><span class="c4">.</span></p>
    <p class="c2"><span class="c5">With whom</span></p>
    <p class="c2"><span class="c6">We may share information as discussed below, </span><span class="c6">but we</span><span>&nbsp;will not
            sell it to advertisers</span><span class="c4">.</span></p>
    <p class="c2"><span class="c1">Others working for OneChart. </span><span class="c4">OneChart uses certain trusted third parties (for
            example, providers of customer support and IT services) to help us provide, improve, and protect our Services.
            These third parties will not be given access to your health information. Access to your non-health related account
            identifying information will be provided only to perform tasks on our behalf in compliance with this Privacy
            Policy, and we&#39;ll remain responsible for their handling of your information per our instructions.</span></p>
    <p
        class="c2"><span class="c1">OneChart administrators.</span><span>&nbsp;Our Services are designed to operate as your private electronic
            courier. Like any good courier it is our policy not to view the contents of your package. When you initiate the
            flow of your health information through the OneChart conduit, </span><span>only you have permission to view health
            information that could identify you</span><span class="c4">. Such identifiable health information is called protected
            health information. No person at OneChart views such information without your consent. No software at OneChart
            processes such information for any purpose other than to enable you to view it. Our Services are designed to
            organize and format such information in a user friendly format but OneChart does not process or perform analysis
            of such information on behalf of any health care provider or any other person or entity. &nbsp;When you use OneChart
            to request such information from a provider, HIPAA trained staff at your provider may view your protected health
            information as they would in the normal course of processing your request to give you access your health information.</span></p>
    <p
        class="c2"><span class="c1">Aggregate data sharing. </span><span class="c4">We strive to make the world a better place by helping
            researchers learn better ways to end human suffering caused by disease. You can consent to allow us to share
            your aggregate health data with researchers and for general insight. We will never share your personally identifiable
            health information and will only share aggregate data with your consent. Aggregate data means any and all of
            your personal information is first removed from the data before it is shared so that no person or entity can
            identify you. &nbsp;At any time, including before you use the Services, you can refuse to consent to aggregate
            data sharing. We encourage you to participate with us in this important initiative but never penalize users who
            do not consent. You are free to enjoy the same full functionality of our Services regardless of your aggregate
            data sharing preferences.</span></p>
    <p class="c2"><span class="c1">Other applications</span><span>. You can also give third parties access to your information and account&mdash;for
            example, via&nbsp;</span><span class="c11">OneChart APIs</span><span class="c4">. Just remember that their use
            of your information will be governed by their privacy policies and terms.</span></p>
    <p class="c2"><span class="c1">Law &amp; Order</span><span>. We may disclose your information to third parties if we determine that
            such disclosure is reasonably necessary to (a) comply with the law; (b) </span><span>protect any person from
            death or serious bodily injury</span><span class="c4">; (c) prevent fraud or abuse of OneChart or our users;
            or (d) protect Onechart&rsquo;s property rights.</span></p>
    <p class="c2"><span>Stewardship of your data is critical to us and a responsibility that we embrace. We believe that our users&#39;
            data should receive the same legal protections regardless of whether it&#39;s stored on our services or on their
            home computer&#39;s hard drive. We&#39;ll abide by our OneChart </span><span>Government Request Principles&nbsp;</span><span
            class="c4">when receiving, scrutinizing and responding to government requests (including national security requests)
            for our users&#39; data:</span></p>
    <p class="c3"><span class="c4">Be transparent,</span></p>
    <p class="c3"><span class="c4">Protect all users, and</span></p>
    <p class="c3"><span class="c4">Provide trusted services.</span></p>
    <p class="c2"><span class="c5">How</span></p>
    <p class="c2"><span class="c1">Security</span><span>. We are committed to protecting the security of your personal information and
            we will take reasonable steps to protect your personal information from misuse, interference, loss, unauthorized
            access, modification or disclosure. We use technologies and processes such as access control procedures, network
            firewalls, </span><span>encryption and physical security</span><span class="c4">. When you complete one of our
            online forms or contact us through our website, we ensure that your contact details are stored on password protected
            databases.</span></p>
    <p class="c2"><span class="c1">Retention</span><span class="c4">. We&#39;ll retain information you store on our Services for as long
            as we need it to provide you the Services. We will destroy or permanently de-identify any of your information
            which is in our possession or control and which we no longer needed for the purpose for which it was collected.</span></p>
    <p
        class="c2"><span>But please note: (1) there might be some latency in deleting this information from our servers and back-up storage;
            and (2) we may retain this information if necessary to comply with our legal obligations, resolve disputes, or
            enforce our agreements. </span><span>You can access your personal information by logging into your OneChart account.</span></p>
    <p
        class="c2"><span class="c10">If you have a complaint or concern about privacy issues</span><span class="c4">:</span></p>
    <p class="c2"><span>Such as:</span></p>
    <p class="c2"><span class="c4">(a)&nbsp;questions or comments about our Privacy Policy; </span></p>
    <p
        class="c2"><span class="c4">(b)&nbsp;you believe we did not agree to provide you with
            access to your personal information; or </span></p>
    <p class="c2"><span class="c4">(c)&nbsp;you have or a complaint about our information handling
            practices, </span></p>
    <p class="c2"><span>We ask that you first submit any such complaints directly to us via support</span><span>@</span><span>onecharthealth.com.
            If you aren&#39;t satisfied with our response, you &nbsp;</span><span>have the right to file a complaint with
            the Federal Privacy Commissioner</span><span class="c4">.</span></p>
    <p class="c2"><span class="c4">How to contact us:</span></p>
    <p class="c2"><span class="c4">By email: support@onecharthealth.com</span></p>
    <p class="c2"><span class="c4">By telephone: (801) 683-5354</span></p>
    <p class="c2" id="h.gjdgxs"><span class="c5">Changes</span></p>
    <p class="c2"><span class="c4">If we are involved in a reorganization, merger, acquisition or sale of our assets, your information
            may be transferred as part of that deal. We will notify you (for example, via a message to the email address
            associated with your account) of any such deal and outline your choices in that event.</span></p>
    <p class="c2"><span class="c4">We may revise this Privacy Policy from time to time, and will post the most current version on our website.
            If a revision meaningfully reduces your rights, we will notify you.</span></p>
    <p class="c2"><span class="c9">Contact</span></p>
    <p class="c2"><span>Have questions or concerns about OneChart, our Services and privacy? Contact us at&nbsp;</span><span class="c11">support@onecharthealth.com</span><span>.</span></p>
    <p
        class="c0"><span class="c4"></span></p>
          </v-card-text>
    </v-card>
      </v-dialog>
</template>

<style scoped>

       .lst-kix_list_1-3>li:before {
            content: "\0025aa  "
        }

        .lst-kix_list_1-4>li:before {
            content: "\0025aa  "
        }

        ul.lst-kix_list_1-0 {
            list-style-type: none
        }

        .lst-kix_list_1-7>li:before {
            content: "\0025aa  "
        }

        .lst-kix_list_1-5>li:before {
            content: "\0025aa  "
        }

        .lst-kix_list_1-6>li:before {
            content: "\0025aa  "
        }

        ul.lst-kix_list_1-3 {
            list-style-type: none
        }

        .lst-kix_list_1-0>li:before {
            content: "\0025cf  "
        }

        ul.lst-kix_list_1-4 {
            list-style-type: none
        }

        .lst-kix_list_1-8>li:before {
            content: "\0025aa  "
        }

        ul.lst-kix_list_1-1 {
            list-style-type: none
        }

        ul.lst-kix_list_1-2 {
            list-style-type: none
        }

        ul.lst-kix_list_1-7 {
            list-style-type: none
        }

        .lst-kix_list_1-1>li:before {
            content: "o  "
        }

        .lst-kix_list_1-2>li:before {
            content: "\0025aa  "
        }

        ul.lst-kix_list_1-8 {
            list-style-type: none
        }

        ul.lst-kix_list_1-5 {
            list-style-type: none
        }

        ul.lst-kix_list_1-6 {
            list-style-type: none
        }

        ol {
            margin: 0;
            padding: 0
        }

        table td,
        table th {
            padding: 0
        }

        .c5 {
            color: #000000;
            font-weight: 700;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 14pt;
            font-family: "Arial";
            font-style: normal
        }

        .c4 {
            color: #000000;
            font-weight: 400;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 11pt;
            font-family: "Arial";
            font-style: normal
        }

        .c8 {
            color: #000000;
            font-weight: 700;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 11pt;
            font-family: "Arial";
            font-style: normal
        }

        .c9 {
            color: #000000;
            font-weight: 700;
            text-decoration: none;
            vertical-align: baseline;
            font-size: 12pt;
            font-family: "Arial";
            font-style: normal
        }

        .c0 {
            padding-top: 0pt;
            padding-bottom: 12pt;
            line-height: 1.1500000000000001;
            orphans: 2;
            widows: 2;
            text-align: left;
            height: 11pt
        }

        .c3 {
            padding-top: 0pt;
            padding-bottom: 6pt;
            line-height: 1.0;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        .c2 {
            padding-top: 0pt;
            padding-bottom: 12pt;
            line-height: 1.1500000000000001;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        .c11 {
            text-decoration-skip-ink: none;
            -webkit-text-decoration-skip: none;
            text-decoration: underline
        }

        .c7 {
            max-width: 468pt;
            padding: 72pt 72pt 72pt 72pt
        }

        .c12 {
            font-size: 14pt
        }

        .c6 {
            background-color: #ffffff
        }

        .c1 {
            font-style: italic
        }

        .c10 {
            font-weight: 700
        }

        .title {
            padding-top: 24pt;
            color: #000000;
            font-weight: 700;
            font-size: 36pt;
            padding-bottom: 6pt;
            font-family: "Arial";
            line-height: 1.1500000000000001;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        .subtitle {
            padding-top: 18pt;
            color: #666666;
            font-size: 24pt;
            padding-bottom: 4pt;
            font-family: "Georgia";
            line-height: 1.1500000000000001;
            page-break-after: avoid;
            font-style: italic;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        li {
            color: #000000;
            font-size: 11pt;
            font-family: "Arial"
        }

        p {
            margin: 0;
            color: #000000;
            font-size: 11pt;
            font-family: "Arial"
        }

        h1 {
            padding-top: 24pt;
            color: #000000;
            font-weight: 700;
            font-size: 24pt;
            padding-bottom: 6pt;
            font-family: "Arial";
            line-height: 1.1500000000000001;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h2 {
            padding-top: 5pt;
            color: #000000;
            font-weight: 700;
            font-size: 18pt;
            padding-bottom: 5pt;
            font-family: "Times New Roman";
            line-height: 1.0;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h3 {
            padding-top: 14pt;
            color: #000000;
            font-weight: 700;
            font-size: 14pt;
            padding-bottom: 4pt;
            font-family: "Arial";
            line-height: 1.1500000000000001;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h4 {
            padding-top: 12pt;
            color: #000000;
            font-weight: 700;
            font-size: 12pt;
            padding-bottom: 2pt;
            font-family: "Arial";
            line-height: 1.1500000000000001;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h5 {
            padding-top: 11pt;
            color: #000000;
            font-weight: 700;
            font-size: 11pt;
            padding-bottom: 2pt;
            font-family: "Arial";
            line-height: 1.1500000000000001;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

        h6 {
            padding-top: 10pt;
            color: #000000;
            font-weight: 700;
            font-size: 10pt;
            padding-bottom: 2pt;
            font-family: "Arial";
            line-height: 1.1500000000000001;
            page-break-after: avoid;
            orphans: 2;
            widows: 2;
            text-align: left
        }

</style>

<script>
import DialogMixin from '@/core/mixins/DialogMixin'

export default {
  name: 'TermsOfUse',
  mixins: [DialogMixin],
  data() {
    return {
      addendum: false,
      opened: false
    }
  },
  methods: {
    onClose() {
      this.opened = false
    },
    onOpen() {
      this.opened = true
    }
  },
  mounted() {
    this.$on('open', this.onOpen)
    this.$on('close', this.onClose)
  }
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/PrivacyPolicyDialog.vue